"use client";

import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import type { UseFormRegisterReturn } from "react-hook-form";
import { authFieldClassName, fieldClassName } from "@/components/auth/auth-card";

export function PasswordField({
  id,
  autoComplete,
  invalid,
  registration,
  variant = "default",
}: {
  id: string;
  autoComplete: "current-password" | "new-password";
  invalid?: boolean;
  registration: UseFormRegisterReturn;
  variant?: "default" | "auth" | "cabinet";
}) {
  const [visible, setVisible] = useState(false);
  const auth = variant === "auth";
  const cabinet = variant === "cabinet";

  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        aria-invalid={invalid || undefined}
        aria-describedby={invalid ? `${id}-error` : undefined}
        className={
          cabinet
            ? "h-12 w-full rounded-[10px] border border-[#d5deea] bg-white px-3 pr-12 text-sm text-[#071936] outline-none focus:border-[#0b63f6]"
            : `${auth ? authFieldClassName : fieldClassName} ${auth ? "pr-24" : "pr-16"}`
        }
        {...registration}
      />
      <button
        type="button"
        className={
          cabinet
            ? "absolute top-1/2 right-1.5 grid size-9 -translate-y-1/2 place-items-center rounded-[8px] text-[#5f6f86] hover:bg-[#f5f8fc] hover:text-[#071936]"
            : auth
              ? "absolute top-1/2 right-1.5 inline-flex h-8 -translate-y-1/2 items-center rounded-md px-2 text-[13px] font-medium text-[var(--m-muted)] hover:text-[var(--m-ink)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--m-accent)]"
              : "absolute top-1/2 right-2 -translate-y-1/2 rounded-md px-2 py-1 text-sm text-muted-foreground hover:text-foreground"
        }
        onClick={() => setVisible((value) => !value)}
        aria-pressed={visible}
        aria-label={cabinet ? (visible ? "Скрыть" : "Показать") : undefined}
      >
        {cabinet ? (
          visible ? <EyeOff className="size-4" aria-hidden="true" /> : <Eye className="size-4" aria-hidden="true" />
        ) : visible ? (
          "Скрыть"
        ) : (
          "Показать"
        )}
      </button>
    </div>
  );
}
